import { Pipe, PipeTransform } from "@angular/core";
import { ClareProcessStep } from "../model/utility.model";

@Pipe({
    name: "lastStepBtn",
})
export class LastStepBtnPipe implements PipeTransform {
    transform(originLabel: string, finalStepLabel: string, currentIndex: number, steps: ClareProcessStep[]): unknown {
        const isLastStep = currentIndex === steps.length - 1;
        return isLastStep ? finalStepLabel : originLabel;
    }
}
